import * as React from 'react'

function SvgVe(props) {
	return (
		<svg viewBox="0 0 180 120" width="1em" height="1em" {...props}>
			<defs>
				<g id="ve_svg__d" transform="translate(0 -36)">
					<g id="ve_svg__c">
						<g id="ve_svg__b">
							<path
								d="M0-5v5h3z"
								fill="#fff"
								transform="rotate(18 0 -5)"
								id="ve_svg__a"
							/>
							<use xlinkHref="#ve_svg__a" transform="scale(-1 1)" />
						</g>
						<use xlinkHref="#ve_svg__b" transform="rotate(72)" />
					</g>
					<use xlinkHref="#ve_svg__b" transform="rotate(-72)" />
					<use xlinkHref="#ve_svg__c" transform="rotate(144)" />
				</g>
			</defs>
			<path d="M0 0h180v120H0z" fill="#cf142b" />
			<path d="M0 0h180v80H0z" fill="#00247d" />
			<path d="M0 0h180v40H0z" fill="#fc0" />
			<g transform="translate(90 84)">
				<g id="ve_svg__f">
					<g id="ve_svg__e">
						<use xlinkHref="#ve_svg__d" transform="rotate(10)" />
						<use xlinkHref="#ve_svg__d" transform="rotate(30)" />
					</g>
					<use xlinkHref="#ve_svg__e" transform="rotate(40)" />
				</g>
				<use xlinkHref="#ve_svg__f" transform="rotate(-80)" />
			</g>
		</svg>
	)
}

export default SvgVe
